// extracted by mini-css-extract-plugin
export default {"fixSlide":"index_fixSlide_g93A-","fixSlideBox":"index_fixSlideBox_3DqY8","fixSlideImg":"index_fixSlideImg_a9fZ5","qr":"index_qr_DKLNL"};